module.exports = __webpack_public_path__ + "media/landing_page/plus-icon-kale-0bf5b952.svg";